export let LocalStorage;

let isLocalStorageWorking = false;
try {
    localStorage.setItem("cw-test", "test");
    localStorage.removeItem("cw-test");
    isLocalStorageWorking = true;
} catch {
    isLocalStorageWorking = false;
}

// chrome storage
if (chrome?.storage) {
    LocalStorage = class LocalStorage {
        static get = (key) => {
            return new Promise((resolve, reject) => {
                chrome.storage?.local.get([key], (result) => {
                    if (chrome.runtime.lastError)
                        reject(chrome.runtime.lastError);

                    resolve(result[key]);
                });
            });
        };

        static set = (key, value) => {
            return new Promise((resolve, reject) => {
                chrome.storage?.local.set({ [key]: value }, () => {
                    if (chrome.runtime.lastError)
                        reject(chrome.runtime.lastError);

                    resolve(value);
                });
            });
        };

        static remove = (key) => {
            return new Promise((resolve, reject) => {
                chrome.storage?.local.remove([key], () => {
                    if (chrome.runtime.lastError)
                        reject(chrome.runtime.lastError);

                    resolve();
                });
            });
        };

        static clear = () => {
            return new Promise((resolve, reject) => {
                chrome.storage?.local.clear(() => {
                    if (chrome.runtime.lastError)
                        reject(chrome.runtime.lastError);

                    resolve();
                });
            });
        };

        static subscribe = (key, callback) => {
            chrome.storage.onChanged.addListener((changes, area) => {
                let changedItems = Object.keys(changes);

                for (let item of changedItems) {
                    if (item === key) {
                        callback(changes[item]);
                    }
                }
            });
        };
    };

    // local storage
} else if (isLocalStorageWorking && window.localStorage) {
    LocalStorage = class LocalStorage {
        static get = (key) => {
            return new Promise((resolve, reject) => {
                let item = localStorage.getItem(key);
                resolve(JSON.parse(item));
            });
        };

        static set = (key, value) => {
            return new Promise((resolve, reject) => {
                localStorage.setItem(key, JSON.stringify(value));
                resolve(value);
            });
        };

        static remove = (key) => {
            return new Promise((resolve, reject) => {
                localStorage.removeItem(key);
                resolve();
            });
        };

        static clear = () => {
            return new Promise((resolve, reject) => {
                localStorage.clear();
                resolve();
            });
        };

        static subscribe = (key, callback) => {
            window.addEventListener("storage", (event) => {
                if (event.key === key) {
                    let response = {
                        newValue: JSON.parse(event.newValue),
                        oldValue: JSON.parse(event.oldValue),
                    };

                    callback(response);
                }
            });
        };
    };

    // cookie storage
} else {
    LocalStorage = class LocalStorage {
        static get = (key) => {
            return new Promise((resolve, reject) => {
                try {
                    let item = document.cookie
                        .split("; ")
                        .find((row) => row.startsWith(key + "="))
                        .split("=")[1];

                    resolve(JSON.parse(item));
                } catch {
                    resolve(null);
                }
            });
        };

        static set = (key, value) => {
            return new Promise((resolve, reject) => {
                document.cookie = key + "=" + JSON.stringify(value);
                resolve(value);
            });
        };

        static remove = (key) => {
            return new Promise((resolve, reject) => {
                document.cookie =
                    key + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                resolve();
            });
        };

        static clear = () => {
            return new Promise((resolve, reject) => {
                document.cookie = "";
                resolve();
            });
        };

        static subscribe = (key, callback) => {
            window.addEventListener("storage", (event) => {
                if (event.key === key) {
                    let response = {
                        newValue: JSON.parse(event.newValue),
                        oldValue: JSON.parse(event.oldValue),
                    };

                    callback(response);
                }
            });
        };
    };
}
